import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataTableBonDeSortieSell from "../../../ui/DataTableBonDeSortieSell";
import { TextField } from "@material-ui/core";
import BDCRecap from "../../ProductSellBTOB/Table/BDCRecap";
import SellingService from "../../../services/SellingService";
const Recap = ({ startLoading, stopLoading }) => {
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [bonCommandeSalesByEtatNo, setData] = useState([]);
  const [bonCommandeSalesByEtatYes, setBonCommandeSalesByEtatYes] = useState([]);

  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const animatedComponents = makeAnimated();

  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");

  const [transactions, setTransactions] = useState([]);
  const [dateBegin, setDateBegin] = useState("any");
  const [search, setSearch] = useState(false);

  const [dateEnd, setDateEnd] = useState("any");
  const handelRecap = () => {
    startLoading();
    SellingService.recapBonCommandeSale(getCurrentUserId(), sessionStorage.getItem("zone"), dateBegin, dateEnd)
      .then((response) => {
        if (response.data.success) {
          setSearch(true)
          setData(response.data.success[0].bonCommandeSalesByEtatNo);
          setBonCommandeSalesByEtatYes(response.data.success[0].bonCommandeSalesByEtatYes)
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      }).finally(()=>{
        stopLoading();
      })
  }

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);


  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    // Check if the value includes a time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // Set seconds to 00 if time exists
      : selectedValue + "T00:00:00"; // Set to the first second of the day (00:00:00) for date input

    setDateBegin(updatedValue);
  };


  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the value includes a time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // Set seconds to 59 if time exists
      : selectedValue + "T23:59:59"; // Set to the last second of the day (23:59:59) for date input

    setDateEnd(updatedValue);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card ">
            <div class="card-body">
              <h5 class="card-title">Recap</h5>
            </div>
          </div>
        </div>
      </section>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={handelRecap}
                    >
                      Valider
                    </button>
                  </div>
                </div>
              </div>
              {(search && (dateBegin !== "any" && dateEnd !== "any")) && <BDCRecap listBDC={bonCommandeSalesByEtatYes} title={"Bon de Commande - Ventes par État (Oui)"} />}
              {(search && (dateBegin !== "any" && dateEnd !== "any")) && <BDCRecap listBDC={bonCommandeSalesByEtatNo} title={"Bon de Commande - Ventes par État (Non)"} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(Recap);
